import { render, staticRenderFns } from "./videoCard.vue?vue&type=template&id=b1160b74&scoped=true&"
import script from "./videoCard.vue?vue&type=script&lang=js&"
export * from "./videoCard.vue?vue&type=script&lang=js&"
import style0 from "./videoCard.vue?vue&type=style&index=0&id=b1160b74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1160b74",
  null
  
)

export default component.exports